import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { Box } from "@mui/material";

import { getMainStyle } from "../styles";
import Navigation from "./Menu/Navigation";
import PageLoader from "./PageLoader";
import {
  DRAWER_WIDTH_OPEN,
  Main,
  StretchContainer,
  SUB_DRAWER_WIDTH_OPEN,
} from "./utils";
import { menuAtom } from "./Menu/SubMenu";
import Banner from "../Banner/Banner";
import { useBanner } from "../Banner/useBanner";

const Layout = () => {
  const menuState = useRecoilValue(menuAtom);
  const location = useLocation();
  // The IA Nancie section renders its own in-page sidebar and displays the
  // banner from within its own layout (DataAssistantLayout), so it must span the
  // full content width (flush against the main menu) instead of the centered container.
  const isFullBleed =
    location.pathname === "/data-assistant" ||
    location.pathname.startsWith("/data-assistant/");
  const { banner, isVisible, handleCloseBanner } = useBanner();

  return (
    <Box
      sx={{
        ...getMainStyle,
        paddingLeft: menuState.pinned
          ? `calc(${DRAWER_WIDTH_OPEN}px + ${SUB_DRAWER_WIDTH_OPEN}px)`
          : "60px",
      }}
    >
      <Navigation />
      {!isFullBleed && isVisible && banner && (
        <Banner onCloseBanner={handleCloseBanner} banner={banner} />
      )}
      {/* The Suspense boundary sits below <Navigation />, so downloading a lazy
          route chunk keeps the menu and the banner mounted. */}
      {isFullBleed ? (
        <Box sx={{ display: "flex", flex: "1 1 auto", minHeight: 0 }}>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </Box>
      ) : (
        <StretchContainer maxWidth="xl">
          <Main>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </Main>
        </StretchContainer>
      )}
    </Box>
  );
};

export default Layout;
